module.exports = __webpack_public_path__ + "media/bootstrap-icons/clock-fill-424fe79f.svg";